import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISearchInput from 'UIComponents/input/UISearchInput';
import { FilterQuery } from '../../../consts';
import { useQueryParam } from '../../../utils/hooks';

const DirectorySearchInput = ({
  className = ''
}) => {
  const [searchParam, setSearchParam] = useQueryParam(FilterQuery.search);

  const handleSearchChange = ({
    target: {
      value
    }
  }) => {
    setSearchParam(value || undefined);
  };

  return /*#__PURE__*/_jsx(UIFormControl, {
    "aria-label": "search",
    children: /*#__PURE__*/_jsx(UISearchInput, {
      "data-test-id": "directory-search",
      use: "on-dark",
      placeholder: I18n.text('connectDotCom.directory.searchPlaceholder'),
      className: `m-bottom-6 ${className}`,
      onChange: handleSearchChange,
      value: searchParam
    })
  });
};

export default DirectorySearchInput;